// libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';

// components
import Header from "../../../../components/Header/index";
import LoadingSpinner from "../../../../components/LoadingSpinner/index";
import SearchForm from "../../components/SearchForm/index";
import PageTitle from "../../../../components/PageTitle/index";
import Promotion from "./components/Promotion/index";
import NoResultFound from "../../components/NoResultFound/index";
import SystemErrorMessage from "../../../../components/SystemErrorMessage/index";
import ConnectionDetails from './components/ConnectionDetails';
import MemberSection from './components/MemberSection';
import Promotions from './components/Promotions';
import SubscriptionStatus from './components/SubscriptionStatus';
import moment from "moment/moment";
// services
import MembersApi from "../../../../services/portal-api/MembersApi";
import withAuth from "../../../../services/withAuth";
import AuthService from "../../../../services/AuthService";
import MemberStats from './components/MemberStats';
import Echo from 'laravel-echo';
import Swal from 'sweetalert';
import NotFound from '../../../NotFound';

class ViewMember extends React.Component {
    constructor(props) {
        super(props);
        const qs = queryString.parse(props.location.search);
        const member = this.getMember();

        this.state = {
            name: qs.name || '',
            initialQuery: qs.q || '',
            query: qs.q || '',
            member: member,
            isLoadingMember: (member === null),
            memberError: null,
            isLoadingPromotions: true,
            promotionsResult: [],
            isLoadingSubscriptionStatus: true,
            subscriptionStatus: null,
            subscriptionError: null,
            isLoadingResendCard: false,
            resendCardResult: null,
            resendCardError: null,
            isLoadingComment: false,
            sync: false,
            isCheckboxChecked: false,
            countryCode: this.countryCode(),
            actualSearchKey: qs.actualSearchKey || '',
            buttonName: "Delete",
            disableButton: false,
        };

        this.getPromotionsCallId = null;
        this.getSubscriptionStatusCallId = null;
    }

    componentDidMount() {
        // --------------------------------------------------------------------------------------------
        // Commenting out WebSocket script for now as configuring with load balancer is not yet done
        // --------------------------------------------------------------------------------------------
        
        // try {
        //     window.Echo.channel('member-lookup')
        //         .listen('.member-lookup', (data) => {
        //             this._loadMember(true);
        //         });

        //     this._loadMember(true);
        // } catch (e) {
        //     console.log("echo server is not running", e);
        //     this._loadMember(true);
        // }

        // --------------------------------------------------------------------------------------------
        // End
        // --------------------------------------------------------------------------------------------

        this._loadMember(true);

        // const parsed = queryString.parse(location.search);
        // this.setState({
        //     isCheckboxChecked: (parsed.actualSearchKey == parsed.q) ? false : true,
        // })
        
    }

    countryCode() {
        const url = window.location.href;
        if(this.getLastDomainPartFromUrl(url) == 'nz') {
            return 'NZ';
        } else {
            return 'AU';
        }
    }

    getLastDomainPartFromUrl = (url) => {
        const urlObj = new URL(url);
        const domainParts = urlObj.hostname.split(".");
        return domainParts[domainParts.length - 1];
    }

    handleSync = (futuraContactId) => {
        this.setState({
            isLoadingMember: true
        })
        MembersApi.fetchFuturaCustomer((result) => {
            if (result.success) {
                this._loadMember(true);
                this.setState({
                    isLoadingMember: false
                });

                swal("", "Contact synced successfully!", "success", {
                    buttons: false,
                    timer: 3000
                });

            } else {
                this.setState({
                    isLoadingMember: false
                });
            }
        }, futuraContactId);
    }

    handleDeleteAccount = (givexId) => {
        this.setState({
            promotionsResult: []
        });
        this._loadMember(false);
    }


    handleButtonNameChange = () => {
        this.setState((prevState) => {
            return { 
                buttonName: prevState.buttonName == "Delete" ? "Deleting..." : "Delete",
                disableButton: true
            };
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.getPromotionsCallId = null;
            this.getSubscriptionStatusCallId = null;

            this.setState({
                member: '',
                promotionsResult: [],
                isLoadingMember: true,
            }, this._loadMember);
        }
    }

    updatePageTitle = () => {
        const memberName = this.state.name || 'View Member';
        document.title = memberName + ' - Member Lookup - duskPortal';
    };

    _loadMember = (isFirstLoad) => {
        this.updatePageTitle();
        document.body.className = 'page--blue';
        const memberId = this.props.match.params.id;

        // Search for member
        // TODO: this could be tidier as a promise chain...
        this.getMemberCallId = MembersApi.getMember(memberId, (result, callId) => {

            // Check if we're still interested in this response
            if (callId !== this.getMemberCallId) {
                return;
            }

            if (result.success) {
                this.setState({
                    isLoadingMember: false,
                    member: result.json.member
                }, () => {
                    this._attemptToLoadAdditionalDetails();

                    // poll every 20mnts, unless we expect changes to occur imminently
                    let pollTime = 1200000;
                    const imminentUpdate = (
                        this.state.member === null ||
                        this.state.member.isPendingUpdate ||
                        this.state.member.isPending ||
                        this.state.member.updateDidFail
                    );
                    if (imminentUpdate) {
                        pollTime = 40000;
                    }

                    setTimeout(this._loadMember, pollTime);

                    // const doNotPoll = (this.state.member !== null || this.state.member.createDidFail || this.state.member.updateDidFail || this.state.member.exportedToDotDigital);
                    // if (doNotPoll == false) {
                    //     pollTime = 10000;
                    //     setTimeout(this._loadMember, pollTime);
                    // }
                });

                // Fetch follow-up data
                // this._attemptToLoadAdditionalDetails();
            }
            else {
                // Check for auth
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoadingMember: false,
                        isLoadingPromotions: false,
                        isLoadingSubscriptionStatus: false,
                    });
                    return;
                }

                this.setState({
                    isLoadingMember: false,
                    isLoadingPromotions: false,
                    memberError: (result.json && result.json.error) ? result.json.error : null,
                });

            }
        }, !isFirstLoad);

        // Attempt to load initial details right away in case already have a member from state
        this._attemptToLoadAdditionalDetails();
    };

    _attemptToLoadAdditionalDetails = () => {
        const { member } = this.state;
        if (!member || !member.email) {
            this.setState({
                isLoadingPromotions: false,
                isLoadingSubscriptionStatus: false,
                subscriptionStatus: {
                    status: 'No email address',
                    statusHelp: '',
                },
            });
            return;
        }
        console.log(this.props.match.params.id);
        // Only load promos once
        if (this.getPromotionsCallId === null && member.email) {
            this.setState({
                isLoadingPromotions: true,
            });
            this.getPromotionsCallId = MembersApi.getPromotions(
                member.rewardsCardNumber,
                this.onPromotionsLoaded
            );
        }

        // Only load subscription once
        if (this.getSubscriptionStatusCallId === null && member.email) {
            this.setState({
                isLoadingSubscriptionStatus: true,
                subscriptionStatus: null,
            });
            this.getSubscriptionStatusCallId = MembersApi.getSubscriptionStatus(
                member.email,
                this.onSubscriptionStatusLoaded
            );
        }

    };

    onPromotionsLoaded = (result, callId) => {
        // Check if we're still interested in this response
        if (callId !== this.getPromotionsCallId) {
            return;
        }

        if (result.success) {

            this.setState({
                isLoadingPromotions: false,
                promotionsResult: result.json,
            });
        }
        else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingPromotions: false,
                });
                return;
            }
            this.setState({
                promotionsError: result.json.error,
                isLoadingPromotions: false,
            });
        }
    };

    onPromotionsLoadedOnToggle = (result, callId) => {
        // Check if we're still interested in this response
        if (callId !== this.getPromotionsCallId) {
            return;
        } scrollTo

        if (result.success) {
            let message = {
                storename: sessionStorage.getItem('store-name'),
                usrname: AuthService.getName(),
                admin: AuthService.isAdmin() ? "Yes" : "No",
                changes: []
            };


            message['changes'].push({ field: "promo-resend", prev: " -- ", next: result.json.message });

            if (message['changes'].length > 0) {

                MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                    if (result.success) {
                        console.log('saved');
                    }
                });
            }
            this.setState({
                isLoadingPromotions: false,
                promotionsResult: result.json,
            });
        }
        else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingPromotions: false,
                });
                return;
            }
            this.setState({
                promotionsError: result.json.error,
                isLoadingPromotions: false,
            });
        }
    };

    onPromotionsLoadedCertGen = (result, callId, promo = null) => {
        // Check if we're still interested in this response
        if (callId !== this.getPromotionsCallId) {
            return;
        }

        if (result.success) {
            let message = {
                storename: sessionStorage.getItem('store-name'),
                usrname: AuthService.getName(),
                admin: AuthService.isAdmin() ? "Yes" : "No",
                changes: []
            };

            const promoMessage = promo ? `${promo.toLowerCase()}` : 'New welcome cert generated';
            message['changes'].push({ field: "re-generate", prev: " -- ", next: `New ${promoMessage} generated` });

            if (message['changes'].length > 0) {

                MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                    if (result.success) {
                        console.log('saved');
                    }
                });
            }

            this.setState({
                isLoadingPromotions: false,
                promotionsResult: result.json,
            }, () => {     ////// load subsciption status again
                this.setState({
                    isLoadingSubscriptionStatus: true,
                    subscriptionStatus: null,
                });
                const { member } = this.state;
                this.getSubscriptionStatusCallId = MembersApi.getSubscriptionStatus(
                    member.email,
                    this.onSubscriptionStatusLoaded
                );
            });
        }
        else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingPromotions: false,
                });
                return;
            }
            this.setState({
                promotionsError: result.json.error,
                isLoadingPromotions: false,
            });
        }
    };

    _onToggleSubscriptionStatus = (event) => {
        event.preventDefault();

        if (this.state.subscriptionStatus === null) {
            return;
        }

        this.setState({
            isLoadingSubscriptionStatus: true,
            subscriptionError: null,
        });

        this.getSubscriptionStatusCallId = null;
        this.getSubscriptionStatusCallId = MembersApi.setSubscriptionStatus(
            this.state.member.slug,
            (!this.isOptedIn()) ? 'subscribe' : 'unsubscribe',
            this.onSubscriptionStatusLoadedOnToggle
        );
    };

    _onPressResendCard = (event) => {
        this.setState({
            isLoadingResendCard: true,
            resendCardError: null,
            resendCardResult: null,
        });

        // Api call
        this.resendCardCallId = MembersApi.resendCard(
            this.state.member.slug,
            this.onResendCardLoaded
        );
    };

    _onSaveComment = (comment, callback) => {
        this.setState({
            isLoadingComment: true,
        });

        let message = {
            storename: sessionStorage.getItem('store-name'),
            usrname: AuthService.getName(),
            admin: AuthService.isAdmin() ? "Yes" : "No",
            changes: []
        };

        const { member } = this.state;
        if (comment != member.comments.comments) {
            message['changes'].push({ field: "comment", prev: member.comments.comments, next: comment });
        }

        if (message['changes'].length > 0) {

            MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                if (result.success) {
                    console.log('saved');
                }
            });
        }

        // Api call
        const saveCommentCallId = MembersApi.saveComment(
            this.state.member.slug,
            comment,
            (result, callId) => {
                if (callId !== saveCommentCallId) {
                    return;
                }
                if (result.success) {
                    const member = { ...this.state.member };
                    member.comments = result.json.comments;
                    this.setState({
                        member: member,
                        isLoadingComment: false,
                    }, callback);
                }
                else {

                    if (result.status === 401) {
                        this.props.sessionExpired();
                        this.setState({
                            isLoadingComment: false,
                        });
                        return;
                    } else {
                        this.setState({
                            isLoadingComment: false,
                        });
                    }
                }
            }
        );
    };

    _onDeleteComment = (callback) => {
        this.setState({
            isLoadingComment: true,
        });

        // Api call
        const saveCommentCallId = MembersApi.deleteComment(
            this.state.member.slug,
            (result, callId) => {
                if (callId !== saveCommentCallId) {
                    return;
                }
                if (result.success) {
                    const member = { ...this.state.member };
                    let message = {
                        storename: sessionStorage.getItem('store-name'),
                        usrname: AuthService.getName(),
                        admin: AuthService.isAdmin() ? "Yes" : "No",
                        changes: []
                    };
                    if (result.json.comments != member.comments.comments) {
                        message['changes'].push({ field: "comment", prev: member.comments.comments, next: result.json.comments });
                    }
                    if (message['changes'].length > 0) {

                        MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                            if (result.success) {
                                console.log('saved');
                            }
                        });
                    }
                    member.comments = result.json.comments;
                    this.setState({
                        member: member,
                        isLoadingComment: false,
                    }, callback);
                }
                else {
                    if (result.status === 401) {
                        this.props.sessionExpired();
                        this.setState({
                            isLoadingComment: false,
                        });
                        return;
                    } else {
                        this.setState({
                            isLoadingComment: false,
                        });
                    }
                }
            }
        );
    }

    onResendCardLoaded = (result, callId) => {
        // Check if we're still interested in this response
        if (callId !== this.resendCardCallId) {
            return;
        }

        if (result.success) {
            ////// update-hist entry //////
            let message = {
                storename: sessionStorage.getItem('store-name'),
                usrname: AuthService.getName(),
                admin: AuthService.isAdmin() ? "Yes" : "No",
                changes: []
            };


            message['changes'].push({ field: "card resend", prev: " -- ", next: result.json.message });

            if (message['changes'].length > 0) {

                MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                    if (result.success) {
                        console.log('saved');
                    }
                });
            }
            ////// end update-hist entry //////
            this.setState({
                isLoadingResendCard: false,
                resendCardResult: result.json.message,
            });
        }
        else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingResendCard: false,
                });
                return;
            }
            this.setState({
                resendCardError: result.json.error,
                isLoadingResendCard: false,
            });
        }
    };

    _onResendPromotion = (promotion) => {
        this.setState({
            isLoadingPromotions: true,
            promotionsError: null,
        });

        // Api call
        this.getPromotionsCallId = MembersApi.resendPromotion(
            this.state.member.slug,
            promotion.id,
            promotion.key,
            this.onPromotionsLoadedOnToggle
        );
    };

    _onGeneratePromotion = (promo, unsubs, wasSubscribed) => {
        
        this.setState({
            isLoadingPromotions: true,
            promotionsError: null,
        });

        // Capture `promo` in the closure, even if it's optional
        const onGenCompleteWithPromo = (result, callId) => {
            this.onGenComplete(result, callId, promo);
        };

        this.getPromotionsCallId = MembersApi.genPromotions(this.state.member.slug, promo, unsubs, wasSubscribed, onGenCompleteWithPromo);
    }

    onGenComplete = (result, callId, promo = null) => {
        if (callId !== this.getPromotionsCallId) {
            return;
        }
        if (result.success) {
            const { member } = this.state;
            // Capture `promo` in the closure for the next step
            const onPromotionsLoadedCertGenWithPromo = (result, callId) => {
                this.onPromotionsLoadedCertGen(result, callId, promo);
            };

            this.getPromotionsCallId = MembersApi.getPromotions(
                member.rewardsCardNumber,
                onPromotionsLoadedCertGenWithPromo
            );
        } else {
            const { member } = this.state;
            this.setState({
                promotionsError: result.json.error,
            }, () => {
                this.getPromotionsCallId = MembersApi.getPromotions(member.rewardsCardNumber, this.onPromotionsLoadedButContactSuppressed);
            });
        }
    }

    onPromotionsLoadedButContactSuppressed = (result, callId) => {
        // Check if we're still interested in this response
        if (callId !== this.getPromotionsCallId) {
            return;
        }

        if (result.success) {
            let message = {
                storename: sessionStorage.getItem('store-name'),
                usrname: AuthService.getName(),
                admin: AuthService.isAdmin() ? "Yes" : "No",
                changes: []
            };


            message['changes'].push({ field: "re-generate", prev: " -- ", next: "New welcome cert generated" });

            if (message['changes'].length > 0) {

                MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                    if (result.success) {
                        console.log('saved');
                    }
                });
            }

            this.setState({
                isLoadingPromotions: false,
                promotionsResult: result.json,
            }, () => {     ////// load subsciption status again
                this.setState({
                    isLoadingSubscriptionStatus: true,
                    subscriptionStatus: null,
                });
                const { member } = this.state;
                this.getSubscriptionStatusCallId = MembersApi.getSubscriptionStatus(
                    member.email,
                    this.onSubscriptionStatusLoaded
                );
            });
        }
        else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingPromotions: false,
                });
                return;
            }
            this.setState({
                isLoadingPromotions: false,
            });
        }
    };

    onSubscriptionStatusLoaded = (result, callId) => {
        if (callId !== this.getSubscriptionStatusCallId) {
            return;
        }

        if (result.success) {

            this.setState({
                isLoadingSubscriptionStatus: false,
                subscriptionStatus: result.json.data,
            });
        } else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingSubscriptionStatus: false
                });
                return;
            }

            this.setState({
                isLoadingSubscriptionStatus: false,
                subscriptionError: result.json.error
            });
        }
    };

    onSubscriptionStatusLoadedOnToggle = (result, callId) => {
        if (callId !== this.getSubscriptionStatusCallId) {
            return;
        }

        if (result.success) {

            let message = {
                storename: sessionStorage.getItem('store-name'),
                usrname: AuthService.getName(),
                admin: AuthService.isAdmin() ? "Yes" : "No",
                changes: []
            };

            const { subscriptionStatus } = this.state;
            if (subscriptionStatus.status != undefined && subscriptionStatus.status != result.json.data.status) {
                message['changes'].push({ field: "newsletter", prev: subscriptionStatus.status, next: result.json.data.status });
            }

            if (message['changes'].length > 0) {

                MembersApi.updateMemberHistory(this.props.match.params.id, { data: JSON.stringify(message) }, (result) => {
                    if (result.success) {
                        console.log('saved');
                    }
                });
            }

            this.setState({
                isLoadingSubscriptionStatus: false,
                isLoadingPromotions: true,
                subscriptionStatus: result.json.data,
            }, () => {
                const { member } = this.state;
                this.getPromotionsCallId = MembersApi.getPromotions(
                    member.rewardsCardNumber,
                    this.onPromotionsLoaded
                );
            });
        } else {
            if (result.status === 401) {
                this.props.sessionExpired();
                this.setState({
                    isLoadingSubscriptionStatus: false
                });
                return;
            }

            this.setState({
                isLoadingSubscriptionStatus: false,
                subscriptionError: result.json.error
            });
        }
    };

    onQueryChange = (query) => {
        this.setState({
            query: query,
            actualSearchKey: ''
        });
    };

    onSubmit = (event) => {
        // Tidy query, strip ' and " from start/end
        let query = this.state.query.replace(/^['"]+|['"]+$/g, '');
        let actualQuery = query;
        // Check if query doesn't end with 'au' or 'nz'
        if (!query.toLowerCase().endsWith('au') && !query.toLowerCase().endsWith('nz') && this.state.isCheckboxChecked) {

            this.setState({
                actualSearchKey: query
            }, () => {
                alert(this.state.actualSearchKey);
            });
            // Add countryCode from state after a space
            query += ' ' + this.state.countryCode;
        }
        this.onQueryChange(query);
        // Update URL
        this.props.history.push('/members?q=' + encodeURIComponent(query) + '&actualSearchKey=' + actualQuery);
    };

    handleCheckboxChange = () => {
        this.setState(prevState => ({
            isCheckboxChecked: !prevState.isCheckboxChecked
        }));
    }

    isSubscribed = () => {
        const { subscriptionStatus } = this.state;
        return (
            subscriptionStatus !== null && (
                subscriptionStatus.status.toLowerCase() === 'subscribed' ||
                subscriptionStatus.status.toLowerCase() === 'pendingoptin' ||
                subscriptionStatus.status.toLowerCase() === 'unsubscribed' 
            )
        );
    };

    isOptedIn = () => {
        const { subscriptionStatus } = this.state;
        return (
            subscriptionStatus !== null && (
                subscriptionStatus.status.toLowerCase() === 'subscribed' ||
                subscriptionStatus.status.toLowerCase() === 'pendingoptin'
            )
        );
    }

    getMember() {
        const { history } = this.props;

        let member = null;
        if (this.state && this.state.member !== null) {
            member = this.state.member;
        }
        else if (typeof history.location.state !== 'undefined' && typeof history.location.state.member !== 'undefined') {
            member = history.location.state.member;
        }
        // console.log('getMember');
        // console.log("member ",member);

        return member;
    }

    getPromotions() {
        const { member, promotionsResult } = this.state;
        if (promotionsResult && promotionsResult.promotions) {
            return promotionsResult.promotions.map((promotion) => {
                const canResend = (
                    promotion.canResend &&
                    member !== null &&
                    !member.isPending &&
                    member.isActiveRecord &&
                    this.isSubscribed()
                );
                const wasSubscribed = this.isSubscribed();

                let errorMessage;
                if (!promotion.giftcard) {
                    if (!member.birthdate && promotion.key === 'birthday') {
                        errorMessage = (<p>Voucher not valid until birthday is set.</p>);
                    } else {
                        errorMessage = (<p>No voucher on record</p>);
                    }
                }

                if (errorMessage) {
                    return (
                        <Promotion key={promotion.name} promotion={{ ...promotion, canResend, wasSubscribed }} onPressResend={this._onResendPromotion} onPressGenerate={this._onGeneratePromotion}>
                            {errorMessage}
                        </Promotion>
                    );
                } else {
                    return <Promotion key={promotion.name} promotion={{ ...promotion, canResend, wasSubscribed }} onPressResend={this._onResendPromotion} onPressGenerate={this._onGeneratePromotion} />;
                }
            })
        }
        return [];
    }

    toApiLogs = () => {
        const { member } = this.state;
        let failedOn = member.failed_on ;
        let url = '/admin?sec=api';
        let type = '';
        let column = '';
        let token = '';

        if (failedOn.toLowerCase() == 'givex') {
            type = '&type=givex_api';
            column = '&column=Card';
            token = `&token=${member.rewardsCardNumber}`;
            url = `${url}${type}${column}${token}`;
        }
        
        if (failedOn.toLowerCase() == 'futura') {
            type = '&type=futura_api';
            column = '&column=Card';
            token = `&token=${member.rewardsCardNumber}`;
            url = `${url}${type}${column}${token}`;
        }
        
        if (failedOn.toLowerCase() == 'dotdigital') {
            type = '&type=dotdigital_api';
            column = '&column=Card';
            token = `&token=${member.rewardsCardNumber}`;
            url = `${url}${type}${column}${token}`;
        }

        this.props.history.push(`${url}&viewMember=1`);
    }

    render() {
        const { location } = this.props;
        const { isLoadingMember, initialQuery } = this.state;

        const member = this.getMember();
        const memberName = member ? `${member.firstName} ${member.surname}` : 'Finding member...';

        const promotions = this.getPromotions();

        const isResendCardEnabled = (
            member &&
            !member.isPending &&
            member.isActiveRecord &&
            this.isSubscribed()
        );

        const rows = []; let k = 0; const rowstran = [];


        return (
            AuthService.can('view member') ?
                <div>
                    <Header />
                    <main className="content padding--80--bot" role="main">
                        <div className="container container--wide padding--60">
                            <header className="header--page clearfix">
                                <PageTitle back={`/members?q=${encodeURIComponent(initialQuery)}`} title={memberName} />
                                <SearchForm
                                    onQueryChange={this.onQueryChange}
                                    onSubmit={this.onSubmit}
                                    query={this.state.query}
                                    actualSearch={this.state.actualSearchKey}
                            />
                            </header>
                            {AuthService.can('country specific search') && 
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '5px' }}>
                                    <label style={{ marginLeft: 'auto', fontSize: 15 }}>
                                        {this.state.countryCode} Members Only &nbsp; 
                                        <input
                                            type="checkbox"
                                            checked={this.state.isCheckboxChecked}
                                            onChange={this.handleCheckboxChange}
                                        />
                                    </label>
                                </div>
                            }
                            
                            <LoadingSpinner isVisible={isLoadingMember} />
                            {this.state.memberError !== null &&
                                <div className="margin--20--top">
                                    <SystemErrorMessage message={this.state.memberError} />
                                </div>
                            }
                            {!this.state.isLoadingMember && this.state.member === null && this.state.memberError === null && <NoResultFound />}
                            <MemberSection
                                member={member}
                                isResendCardEnabled={isResendCardEnabled}
                                onPressResendCard={this._onPressResendCard}
                                isLoadingResendCard={this.state.isLoadingResendCard}
                                resendCardResult={this.state.resendCardResult}
                                resendCardError={this.state.resendCardError}
                                onSaveComment={this._onSaveComment}
                                onDeleteComment={this._onDeleteComment}
                                isLoadingComment={this.state.isLoadingComment}
                                sync={this.handleSync}
                                deleteAccount={this.handleDeleteAccount}
                                handleButtonNameChange={this.handleButtonNameChange}
                                buttonName={this.state.buttonName}
                                disableButton={this.state.disableButton}
                                toApiLogs={this.toApiLogs}
                            >
                                <div className="col">
                                    <Promotions
                                        isLoading={this.state.isLoadingPromotions}
                                        error={this.state.promotionsError}
                                        message={this.state.promotionsResult ? this.state.promotionsResult.message : null}
                                        member={member}
                                        promotions={promotions}
                                    />
                                    <SubscriptionStatus
                                        member={member}
                                        isLoading={this.state.isLoadingSubscriptionStatus}
                                        status={this.state.subscriptionStatus}
                                        isSubscribed={this.isOptedIn()}
                                        error={this.state.subscriptionError}
                                        onClickToggleStatus={this._onToggleSubscriptionStatus}
                                    />
                                    <MemberStats member={member}></MemberStats>
                                    <ConnectionDetails
                                        member={member}
                                    />
                                </div>
                            </MemberSection>
                        </div>
                    </main>
                </div>
            : <NotFound forbidden={true} />
        );
    }
}

export default withAuth(ViewMember);
